import appConfig from './apiConfig';

export const changePasswordApi = (params) => {
    let objChangePassword = JSON.stringify(params);

    const headers = Object.assign({
        'content-type': "application/json",
        'accept': '*/*'
    });
    const request = new Request(appConfig.siteURL + 'changePassword', {
        method: "POST",
        headers: headers,
        body: objChangePassword
    });

    return fetch(request).then(response => {
        return  response.json().then(changePasswordResponse => {
            return changePasswordResponse;
        });
    }).catch(error => {
        return error;
    });
}



// WEBPACK FOOTER //
// ./src/api/changePasswordApi.js